import React from 'react';
import { Container } from 'styles';
import { NoticeList, Pagination, SubTitle } from 'components';

function NoticeView({ list, boardLabel, noticeList, goDetail, paginationRequest, paginationResult, setPaginationRequest }) {
  return (
    <Container $gap={48} $tGap={48}>
      <SubTitle title={list.subject} desc={list.subjectDesc} />
      <NoticeList list={noticeList} label={boardLabel} hideUserName hideDownloadFile onClick={goDetail} />
      <Pagination paginationRequest={paginationRequest} paginationResult={paginationResult}
          setPaginationRequest={setPaginationRequest}/>
    </Container>
  );
}

export default NoticeView;
